import addScrollingWindow from '@utils/addScrollingWindow';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const initAtComponent = () => ({
  type: types.INIT_AT_COMPONENT,
});

export const set = (key, value) => ({
  type: types.SET,
  key,
  value,
});

export const setSaved = (key, value, hasChanged) => ({
  type: types.SET_SAVED,
  key,
  value,
  hasChanged,
});

export const setKeys = (keys) => ({
  type: types.SET_KEYS,
  keys,
});

export const setKey = (key) => ({
  type: types.SET_KEY,
  key,
});

export const removeKey = (key) => ({
  type: types.REMOVE_KEY,
  key,
});

export const setSavedRecentlyKeys = (keys) => ({
  type: types.SET_SAVED_RECENTLY_KEYS,
  keys,
});

export const setSavedRecentlyKey = (key) => ({
  type: types.SET_SAVED_RECENTLY_KEY,
  key,
});

export const removeSavedRecentlyKey = (key) => ({
  type: types.REMOVE_SAVED_RECENTLY_KEY,
  key,
});

export const setAfterInitialization = (afterInitialization) => ({
  type: types.SET_AFTER_INITIALIZATION,
  afterInitialization,
});

export const removeAllKeys = () => ({ type: types.REMOVE_ALL_KEYS });

export const createTempDashboard = (dashboardType, dashboard, title, options = {}) => ({
  type: types.CREATE_TEMP_DASHBOARD,
  dashboardType,
  dashboard: addScrollingWindow(dashboard),
  title,
  options,
});

export const updateDashboardTitle = (oldTitle, newTitle) => ({
  type: types.UPDATE_DASHBOARD_TITLE,
  oldTitle,
  newTitle,
});

export const updateTempDashboardByTitle = (oldTitle, newTitle, val) => ({
  type: types.UPDATE_TEMP_DASHBOARD_BY_TITLE,
  oldTitle,
  newTitle,
  val,
});

export const createSavedDashboard = (id, dashboardName, dashboardType, dashboard) => ({
  type: types.CREATE_SAVED_DASHBOARD,
  id,
  dashboardName,
  dashboardType,
  dashboard,
});

export const updatedSavedDashboard = (id, name) => ({
  type: types.UPDATED_SAVED_DASHBOARD,
  id,
  name,
});

export const resetSavedDashboard = (id, dashboard) => ({
  type: types.RESET_SAVED_DASHBOARD,
  id,
  dashboard,
});

export const remove = (key, isSaved) => ({
  type: types.REMOVE,
  key,
  isSaved,
});

export const removeAll = () => ({
  type: types.REMOVE_ALL,
});

export const refreshTabs = () => ({ type: types.REFRESH_TABS });

export const setCurrentActiveDashboard = (dashboardConfig) => ({
  type: types.UPDATE_ACTIVE_DASHBOARD,
  dashboardConfig,
});

export const updateAccessedTime = (id) => ({
  type: types.UPDATE_ACCESSED_TIME,
  id
});

export const cleanTempDashboards = () => ({
  type: types.CLEAN_TEMP_DASHBOARDS
});
